/** Only an explicit authentication rejection invalidates an existing session. */
export function sessionRejected(error) {
  return [401, 403].includes(error?.response?.status);
}
export function sessionFailureState(error) {
  return sessionRejected(error) ? 'unauthed' : 'unavailable';
}
export function retryableRead(error) {
  if (error?.code === 'ERR_CANCELED' || error?.config?.signal?.aborted) return false;
  const method = (error?.config?.method || 'get').toLowerCase();
  return method === 'get' && (!error.response || error.response.status === 503);
}
